import { jsxs as u, jsx as s, Fragment as k } from "react/jsx-runtime";
import { useTranslation as v } from "react-i18next";
import { Slider as x } from "../../../../../components/form-elements/slider/slider.js";
import a from "./filter-group.module.less.js";
import { orderBy as y, groupBy as F } from "lodash-es";
import { getLabelForFilterSubGroup as j } from "../../../helpers/filter-functions.js";
const C = ({ groupName: n, filter: p, onChange: t }) => {
  const { label: r, value: d, name: l, isChecked: c, isDisabled: b } = p;
  return /* @__PURE__ */ u("div", { className: a.inputLabelWrapper, children: [
    /* @__PURE__ */ s(
      "input",
      {
        type: "checkbox",
        id: l,
        className: a.input,
        name: l,
        value: d,
        checked: c,
        disabled: b,
        onChange: (o) => t({
          type: "checkbox",
          checked: o.target.checked,
          name: l,
          value: o.target.value,
          group: n
        })
      }
    ),
    /* @__PURE__ */ u("label", { htmlFor: l, className: a.label, children: [
      r && /* @__PURE__ */ s("span", { className: a.text, children: r }),
      /* @__PURE__ */ s("div", { className: [a.checkbox, c ? a.checked : ""].join(" "), children: c && /* @__PURE__ */ s("span", { className: [a.checkmark, "ui-icon-check"].join(" ") }) })
    ] }, l)
  ] });
}, w = ({ title: n, filters: p, onChange: t, selectedFilters: r }) => {
  const d = y(p, ["sortOrder"], ["asc"]), l = F(d, "subgroup");
  return /* @__PURE__ */ u("div", { className: a.wrapper, children: [
    n && /* @__PURE__ */ s("h5", { className: ["space-mt-lg space-mb-xs", a.title].join(" "), children: n }),
    Object.entries(l).map(([c, b]) => {
      const { t: o } = v(), h = j(c, o);
      return /* @__PURE__ */ u(k, { children: [
        h && /* @__PURE__ */ s("p", { className: [a.subGroupLabel, a.text].join(" "), children: h }),
        /* @__PURE__ */ s("ul", { className: a.filterList, children: b.map((e, g) => {
          if (e.type === "checkbox") {
            const m = r.get(e.name), i = {
              value: String(e.value),
              name: e.name,
              label: e.label,
              isChecked: !!(m && m.value === e.value.toString())
            };
            return /* @__PURE__ */ s("li", { className: a.listItem, children: /* @__PURE__ */ s(C, { groupName: e.group, filter: i, onChange: t }) }, e.name + g);
          }
          if (e.type === "slider") {
            const m = r.get(e.name), i = parseInt(m?.value ?? "");
            return /* @__PURE__ */ s("li", { className: a.listItem, children: /* @__PURE__ */ s(
              x,
              {
                name: e.name,
                value: isNaN(i) ? 0 : i,
                labels: e.labels,
                labelClassName: a.text,
                min: e.min,
                max: e.max,
                onValueChange: (N) => t({ type: "slider", name: e.name, value: N[0], group: e.group })
              }
            ) }, e.name + g);
          }
        }) })
      ] });
    })
  ] });
};
export {
  C as FilterCheckbox,
  w as FilterGroup
};
